export default __webpack_public_path__ + "6e4343c.png";